<template>
    <h4 class="font-bold text-primary sm:pr-6">
        <slot></slot>
    </h4>
</template>
